import { render, staticRenderFns } from "./mProjectCard.vue?vue&type=template&id=c8a1b156&"
import script from "./mProjectCard.vue?vue&type=script&lang=js&"
export * from "./mProjectCard.vue?vue&type=script&lang=js&"
import style0 from "./mProjectCard.vue?vue&type=style&index=0&id=c8a1b156&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports